import styled from "styled-components";
import tinycolor from "tinycolor2";
import { cssColors, cssVariables } from "constants/css";

export const PreviewQuickReplyButtons = styled.div<{ isCarousel: boolean; noAvatars: boolean}>`
  padding-left: 38px;
  margin-left: -${cssVariables.gUnitDouble};
  margin-right: -${cssVariables.gUnitDouble};

  ${({ noAvatars }) => noAvatars && `
    padding-left: ${cssVariables.gUnitDouble};
  `}

  ${({ isCarousel }) => isCarousel && `
    overflow-y: hidden;
    display: -webkit-box;
    min-height: 34px;
    overflow-x: scroll;
    display: flex;
    
    &::after {
      content: "";
      width: ${cssVariables.gUnitDouble};
      flex-shrink: 0;
    }
  `}
`;

export const PreviewQuickReplyButton = styled.button<{isCarousel: boolean; color: string}>`
  padding: 7px 12px;
  margin-right: 3px;
  display: inline-block;
  border-radius: 12px;
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
  vertical-align: top;
  margin-bottom: 6px;
  text-align: left;
  user-select: none;
  font-size: ${cssVariables.mainFontSize};
  color: ${({ color }) => color};
  border-color: ${({ color }) => color};
  background-color: ${cssColors.colorWhite};
  outline: none;
  white-space: nowrap;
  
  &:first-child {
    margin-left: 0;
  }
  
  ${({ isCarousel }) => isCarousel && `
    margin-left: 3px;
  `}

  ${({ isCarousel }) => (isCarousel ? "&:active" : "&:hover, &:active")} {
    color: ${({ color }) => (tinycolor(color).isDark() ? cssColors.colorWhite : cssColors.colorBlack)};
    background-color: ${({ color }) => color};
    opacity: .75;

    svg {
      fill: ${cssColors.colorWhite};
    }
  }

  &:active {
    opacity: 1;
  }
`;
